(() => {
  const panels = [...document.querySelectorAll('[data-mq-panel]')];
  const getPanel = (name) => panels.find((panel) => panel.dataset.mqPanel === name);
  const closePanel = (panel) => {
    if (!panel) return;
    if (typeof panel.close === 'function' && panel.open) panel.close();
    panel.removeAttribute('open');
    panel.classList.remove('is-open');
  };
  const openPanel = (name) => {
    const panel = getPanel(name);
    if (!panel) return;
    const scrollPosition = { left: window.scrollX, top: window.scrollY };
    panels.forEach(closePanel);
    if (typeof panel.showModal === 'function') panel.showModal();
    else { panel.setAttribute('open', ''); panel.classList.add('is-open'); }
    const firstInput = panel.querySelector('input, select, button');
    window.requestAnimationFrame(() => {
      window.scrollTo(scrollPosition.left, scrollPosition.top);
      if (firstInput) firstInput.focus({ preventScroll: true });
    });
  };
  document.querySelectorAll('[data-mq-panel-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => openPanel(trigger.dataset.mqPanelOpen));
  });
  document.querySelectorAll('[data-mq-panel-close]').forEach((trigger) => {
    trigger.addEventListener('click', () => closePanel(trigger.closest('[data-mq-panel]')));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') panels.forEach(closePanel);
  });
  const menuToggle = document.querySelector('[data-mq-menu-open]');
  const menu = document.querySelector('[data-mq-menu]');
  if (menuToggle && menu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }
  document.querySelectorAll('[data-mq-country-flag]').forEach((flag) => {
    const image = flag.querySelector('.mq-country-picker__flag-image');
    if (!image) return;
    const showFallback = () => flag.classList.add('is-fallback');
    image.addEventListener('error', showFallback);
    image.addEventListener('load', () => flag.classList.remove('is-fallback'));
    if (image.complete && image.naturalWidth === 0) showFallback();
  });
  const localizationForm = document.querySelector('#mq-localization-form');
  const localizationCountry = localizationForm?.querySelector('[data-mq-country-input]');
  const localizationLanguage = localizationForm?.querySelector('[data-mq-language-picker]');
  const countryPicker = localizationForm?.querySelector('[data-mq-country-picker]');
  const countrySearch = localizationForm?.querySelector('[data-mq-country-search]');
  const countryEmpty = localizationForm?.querySelector('[data-mq-country-empty]');
  const countryCurrentName = localizationForm?.querySelector('[data-mq-country-current-name]');
  const countryCurrentCurrency = localizationForm?.querySelector('[data-mq-country-current-currency]');
  const countryCurrentFlag = localizationForm?.querySelector('.mq-country-picker__summary [data-mq-country-flag]');
  const countryCurrentFlagImage = countryCurrentFlag?.querySelector('.mq-country-picker__flag-image');
  const countryCurrentFlagCode = countryCurrentFlag?.querySelector('.mq-country-picker__flag-code');
  const countryOptions = [...document.querySelectorAll('[data-mq-country-option]')];
  const filterCountries = (query = '') => {
    const normalizedQuery = query.trim().toLocaleLowerCase();
    const visibleCount = countryOptions.reduce((count, option) => {
      const matches = !normalizedQuery || [option.dataset.countryName, option.dataset.countryCurrency, option.value]
        .some((value) => value?.toLocaleLowerCase().includes(normalizedQuery));
      option.hidden = !matches;
      return count + Number(matches);
    }, 0);
    if (countryEmpty) countryEmpty.hidden = visibleCount > 0;
  };
  countryOptions.forEach((option) => {
    option.addEventListener('click', () => {
      if (localizationCountry) localizationCountry.value = option.value;
      countryOptions.forEach((countryOption) => {
        countryOption.setAttribute('aria-selected', String(countryOption === option));
      });
      if (countryCurrentName) countryCurrentName.textContent = option.dataset.countryName || option.value;
      if (countryCurrentCurrency) countryCurrentCurrency.textContent = option.dataset.countryCurrency || '';
      if (countryCurrentFlagImage) countryCurrentFlagImage.src = `https://flagcdn.com/w40/${option.value.toLowerCase()}.png`;
      if (countryCurrentFlagCode) countryCurrentFlagCode.textContent = option.value;
      countryCurrentFlag?.classList.remove('is-fallback');
      const suggestedLanguage = option.dataset.defaultLanguage;
      const canUseSuggestedLanguage = suggestedLanguage && [...(localizationLanguage?.options || [])]
        .some((language) => language.value === suggestedLanguage);

      if (canUseSuggestedLanguage) localizationLanguage.value = suggestedLanguage;
      if (countrySearch) countrySearch.value = '';
      filterCountries();
      if (countryPicker) countryPicker.open = false;
    });
  });
  countrySearch?.addEventListener('input', () => filterCountries(countrySearch.value));
  const fallbackFor = (image) => {
    const product = image.closest('.mq-product');
    const profiles = ['bedding', 'custom', 'seasonal', 'bags', 'rugs'];
    const profile = profiles.find((name) => product?.classList.contains(`mq-product--${name}`));
    return document.body.dataset[`mqFallback${profile ? profile.charAt(0).toUpperCase() + profile.slice(1) : 'Default'}`];
  };
  const applyMediaFallback = (image) => {
    if (image.dataset.mqFallbackApplied === 'true') return;
    const fallback = fallbackFor(image);
    if (!fallback) return;
    image.dataset.mqFallbackApplied = 'true';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.loading = 'eager';
    image.src = fallback;
    image.classList.add('mq-managed-image--fallback');
  };
  document.querySelectorAll('img.mq-managed-image').forEach((image) => {
    image.addEventListener('error', () => applyMediaFallback(image));
    if (image.complete && image.naturalWidth === 0 && !image.closest('[hidden]')) applyMediaFallback(image);
    window.setTimeout(() => {
      if (image.naturalWidth === 0 && !image.closest('[hidden]')) applyMediaFallback(image);
    }, 1400);
  });
  document.querySelectorAll('[data-mq-product-form]').forEach((form) => {
    const variantData = form.querySelector('[data-mq-variants]');
    if (!variantData) return;
    const variants = JSON.parse(variantData.textContent);
    const priceData = JSON.parse(form.querySelector('[data-mq-variant-prices]')?.textContent || '{}');
    const selectedId = form.querySelector('[data-mq-variant-id]');
    const product = form.closest('.mq-product');
    const updateVariant = () => {
      const values = [...form.querySelectorAll('[data-mq-option]:checked')].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
      if (!variant) return;
      if (selectedId) selectedId.value = variant.id;
      const prices = priceData[String(variant.id)] || {};
      const current = product?.querySelector('[data-mq-product-price-current]');
      const compare = product?.querySelector('[data-mq-product-price-compare]');
      const addToBag = form.querySelector('[data-mq-add-to-bag]');
      if (current && prices.price) current.textContent = prices.price;
      if (compare) {
        compare.textContent = prices.compare || '';
        compare.hidden = !prices.compare;
      }
      if (addToBag) {
        addToBag.disabled = !variant.available;
        addToBag.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      product?.dispatchEvent(new CustomEvent('mq:variant-change', { bubbles: true, detail: { product, priceCents: Number(variant.price) } }));
    };
    form.addEventListener('change', updateVariant);
  });
  document.querySelectorAll('[data-mq-gallery]').forEach((gallery) => {
    const controls = [...gallery.querySelectorAll('[data-mq-gallery-target]')];
    const slides = [...gallery.querySelectorAll('[data-mq-gallery-slide]')];
    const stage = gallery.querySelector('.mq-product__stage');
    const showSlide = (target) => {
      slides.forEach((slide) => {
        const active = slide.dataset.mqGallerySlide === target;
        slide.hidden = !active;
        if (active) {
          stage?.style.setProperty('--mq-media-ratio', slide.dataset.mqGalleryRatio || '1');
          slide.querySelectorAll('img[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
        }
      });
      controls.forEach((control) => control.setAttribute('aria-current', String(control.dataset.mqGalleryTarget === target)));
    };
    controls.forEach((control) => control.addEventListener('click', () => showSlide(control.dataset.mqGalleryTarget)));
  });
})();
